import axios_instance from './axios_instance.js'
import common from '@/api/common.js'
import tenants from "@/api/tenants.js";
import orders from "@/api/orders.js";

export default {
    // 公用模块
    common: {
        tags: () => axios_instance.config(common.tags).request(),
        configs: () => axios_instance.config(common.configs).request(),
        captcha: () => axios_instance.config(common.captcha).request(),
        uploadFile: data => 
            axios_instance.config(common.uploadFile).request({
                data: data
            }),
        uploadFilesMulti: data => 
            axios_instance.config(common.uploadFilesMulti).request({
                data: data
            }),
        areas: params => 
            axios_instance.config(common.areas).request({
                params: params
            }),
        ocrBusinessLicense: data =>
            axios_instance.config(common.ocrBusinessLicense).request({
                data: data
            })   
    },
    // 用户模块
    tenants: {
        sendCode: data =>
            axios_instance.config(tenants.sendCode).request({
                data: data
            }),
        login: data =>
            axios_instance.config(tenants.login).request({
                data: data
            }), 
        tenantDetail: id =>
            axios_instance.config(tenants.tenantDetail, {
                id: id
            }).request(),
        tenantEdit: (id, data) =>
            axios_instance.config(tenants.tenantEdit, {
                id: id
            }).request({
                data: data
            }),
        antMiniProgramsDetail: id =>
            axios_instance.config(tenants.antMiniProgramsDetail, {
                id: id
            }).request()
    },
    // 订单模块
    orders: {
        ordersList: params =>
            axios_instance.config(orders.ordersList).request({
                params: params
            }),
        ordersFilters: () => axios_instance.config(orders.ordersFilters).request(), 
        ordersDetail: id =>
            axios_instance.config(orders.ordersDetail, {
                id: id
            }).request(),
        ordersEdit: (id, data) =>
            axios_instance.config(orders.ordersEdit, {
                id: id
            }).request({
                data: data
            }),
        orderWorkOrders: id =>
            axios_instance.config(orders.orderWorkOrders, {
                id: id
            }).request(),
        ordersTransactionRecords: id =>
            axios_instance.config(orders.ordersTransactionRecords, {
                id: id
            }).request(),
    },
};



// WEBPACK FOOTER //
// ./src/models/request.js